/* eslint-disable no-unused-expressions */
import { BoxProps } from 'UIKit/Box/types'
import { howlMapper } from 'config/constants/audio'
import { InhouseGameDetails, InhouseGameType } from 'config/types/game'
import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { breakpointMap } from 'theme/base'
import GameFrame from 'views/GameDetails/GameFrame'
import TournamentDetailsOfGame from 'views/GameDetails/TournamentDetailsOfGame'
import DiceGame from './Dice'
import DiceContext from './Dice/context'
import LimboGame from './Limbo'
import LimboContext from './Limbo/context'
import MineGame from './Mine'
import MineContext from './Mine/context'
import PlinkoGame from './Plinko'
import PlinkoContext from './Plinko/context'
import WheelGame from './Wheel'
import WheelContext from './Wheel/context'
import GameInHouseBottom from './components/GameInHouseBottom'
import { useGameInHouseConfig } from './hooks/useGameInHouseConfig'

const InhouseGame: React.FC<{ game: InhouseGameDetails; isMinimize?: boolean } & BoxProps> = ({
  game,
  isMinimize,
  ...props
}) => {
  const settings = useGameInHouseConfig()
  const { isTablet } = useMatchBreakpoints()

  useEffect(() => {
    // Init audio
    howlMapper.InhouseGameBetPlay
  }, [])

  return (
    <>
      <StyledContainer game={game} isMinimize={isMinimize} m="auto" {...props}>
        {game && game.additionalData.inhouseGameType === InhouseGameType.Plinko && (
          <PlinkoContext game={game}>
            <PlinkoGame game={game} {...settings} />
          </PlinkoContext>
        )}

        {game && game.additionalData.inhouseGameType === InhouseGameType.Limbo && (
          <LimboContext game={game}>
            <LimboGame game={game} {...settings} />
          </LimboContext>
        )}

        {game && game.additionalData.inhouseGameType === InhouseGameType.Dice && (
          <DiceContext game={game}>
            <DiceGame game={game} {...settings} />
          </DiceContext>
        )}

        {game && game.additionalData.inhouseGameType === InhouseGameType.Wheel && (
          <WheelContext game={game}>
            <WheelGame game={game} {...settings} />
          </WheelContext>
        )}

        {game && game.additionalData.inhouseGameType === InhouseGameType.Mine && (
          <MineContext game={game}>
            <MineGame game={game} {...settings} />
          </MineContext>
        )}

        {!isMinimize && <GameInHouseBottom game={game} settings={settings} />}
      </StyledContainer>

      {isTablet && <TournamentDetailsOfGame mt="12px !important" width="100%" />}
    </>
  )
}

const StyledContainer = styled(GameFrame)<{ isMinimize?: boolean }>`
  background: ${({ theme }) => theme.colors.backgroundAlt9};
  max-width: unset !important;
  height: unset !important;

  display: flex;
  flex-direction: column;

  canvas {
    width: 100% !important;
    height: auto !important;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    max-width: auto;
    canvas {
      width: auto !important;
      height: 100% !important;
    }
    min-height: 800px;
    max-height: ${({ theme: { topbarHeight } }) =>
      `calc(var(--screen-height) - ${topbarHeight} - 12px - var(--notification-bar-height))`};
  }

  ${({ theme }) => theme.mediaQueries.xl} {
  }

  @media screen and (max-width: ${breakpointMap.sm}px) {
    padding-top: 0;
    padding-bottom: 56px;
  }
`

export default InhouseGame
